<template>
  <div>
    <TeJobLaravelCover />

    <TeJobAbout>
      <template #title>
        Laravel
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          Laravelを中心とした学習プログラムにおいて
          <br class="hidden md:block">
          受講生の「わからない」をリモートにてサポートしていただきます。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
        <a href="/job">
          テックアカデミーのメンターについて
        </a>
      </template>
    </TeJobAbout>

    <TeJobTarget />

    <TeJobMessage>
      <template #mentoringText>
        1回30分のビデオチャットで受講生からの相談や質問に答えていただきます。
        <br class="hidden md:block">
        時にはペアプログラミングなどのサポートをしていただきます。
        <br class="hidden md:block">
        マンツーマンメンタリングはカリキュラムやチャットで解決できなかった課題を確実に解消させる取り組みです。
      </template>
      <template #chatsupportText>
        15時〜23時の間のシフト制で、
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />

    <TeJobMentor>
      <template #mentorOne>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-suda.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Hiroshi Suda"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Hiroshi Suda
          </h4>
          <p>
            IT業界のキャリアは35年以上。対応言語は、C,C#,Javaなど。現在フリーとして受託開発とプログラミング教育に携わる。プログラミング言語は世界で共通言語でありグローバルな視野を持つことをモットーにしています。
          </p>
        </div>
      </template>
      <template #mentorTwo>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-ishikawa.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Yuri Ishikawa"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Yuri Ishikawa
          </h4>
          <p>
            パソコンを触るのが大好きで、小学生の頃から独学でHTMLなどの勉強を始める。プログラミングで思っている通りに動作したときが楽しいです。
          </p>
        </div>
      </template>
    </TeJobMentor>

    <TeJobMentorSlider />

    <!-- スキル -->
    <section
      id="skill"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pb-[3.75rem] pt-20 lg:pb-10">
        <h2 class="co-heading-2">
          Laravelメンターに必要なスキル
        </h2>
        <div class="grid grid-cols-1 justify-center gap-9 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faHtml5"
                class="size-11 text-[#e44d26]"
              />
            </template>
            <template #title>
              HTML/CSS3
            </template>
            <template #description>
              HTML/CSS の業務経験（2年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-php.png"
                alt="php"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              PHP
            </template>
            <template #description>
              PHPを用いた開発経験（2年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-laravel.png"
                alt="Laravel"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Laravel
            </template>
            <template #description>
              Laravelでの開発経験（1年以上）
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faDatabase"
                class="h-11 w-9 text-[#024365]"
              />
            </template>
            <template #title>
              MySQLのデータ操作
            </template>
            <template #description>
              ターミナルでMySQLのデータ操作（CRUD）の経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faGithub"
                class="h-12 w-11"
              />
            </template>
            <template #title>
              Git/GitHub
            </template>
            <template #description>
              Git/GitHubでの開発経験
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <FontAwesomeIcon
                :icon="faBootstrap"
                class="h-12 w-11 text-[#563d7c]"
              />
            </template>
            <template #title>
              Bootstrap
            </template>
            <template #description>
              Bootstrapでの開発経験
            </template>
          </TeJobSkill>
        </div>
      </div>
    </section>

    <TeJobFlow />

    <TeJobEntry course-name-path="laravel" />
  </div>
</template>

<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'

import TeJobLaravelCover from '~/components/Te/TeJob/Laravel/TeJobLaravelCover.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentor from '~/components/Te/TeJob/TeJobMentor.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'
import TeJobSkill from '~/components/Te/TeJob/TeJobSkill.vue'
import TeJobFlow from '~/components/Te/TeJob/TeJobFlow.vue'
import TeJobEntry from '~/components/Te/TeJob/TeJobEntry.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHtml5, faGithub, faBootstrap } from '@awesome.me/kit-65d95819ce/icons/classic/brands'
import { faDatabase } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

useJobHead()

useHead({
  title: 'Laravel講師（メンター）募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするLaravelメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterTitle: 'Laravel講師（メンター）募集',
      twitterDescription:
        '受講生をサポートするLaravelメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterImage: '/_nuxt/ogp/og-image-mentor-laravel.jpg',
      ogTitle: 'Laravel講師（メンター）募集',
      ogDescription:
        '受講生をサポートするLaravelメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      ogUrl: '/job/laravel',
      ogImage: '/_nuxt/ogp/og-image-mentor-laravel.jpg',
    }),
  ],
})
</script>
